package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedParking(
    val updatedAtEpochMillis: Long,
    val spots: List<CachedParkingSpot>,
)
